import { Outlet, Link } from 'react-router';

import esCloudLogo from '@/assets/es-cloud.png';
import { LegalFooter } from '@/legal';

/**
 * Simple centered layout for setup flows (tenant creation, plan selection, etc.)
 * Designed to support future wizard-style workflows.
 */
export function BlankLayout() {
    return (
        <div className="flex min-h-screen flex-col">
            {/* Header */}
            <header className="border-b bg-background">
                <div className="mx-auto flex h-14 sm:max-w-5/6 lg:max-w-4/5 xl:max-w-3/4 items-center px-6">
                    <Link to="/" className="flex items-center gap-2 font-semibold">
                        <img src={esCloudLogo} alt="ESCloud" className="h-5 w-5" />
                        <span>ESCloud</span>
                    </Link>
                </div>
            </header>

            {/* Main content */}
            <main className="flex flex-1 flex-col items-center p-6">
                <div className="flex-1" />
                <div className="w-full sm:max-w-5/6 lg:max-w-4/5 xl:max-w-3/4">
                    <Outlet />
                </div>
                <div className="flex-3" />
            </main>

            <LegalFooter />
        </div>
    );
}
